import React from "react";

// Award Images (update paths)
import Karlad02 from "../../../images/award/Karla..jpg";
import Buenhd03 from "../../../images/award/Buenh.jpg";
import Ale04 from "../../../images/award/Ale.jpg";
import Gera05 from "../../../images/award/Beni.jpg";
import Dani06 from "../../../images/award/Dani.jpg";
import Davidd07 from "../../../images/award/david.jpg";
import Ferd08 from "../../../images/award/Fer.jpg";
import Chris09 from "../../../images/award/Chris1.jpg";
import Miguel10 from "../../../images/award/Miguel.jpg";
import { Link } from "react-router-dom";

const awards1 = [
    Gera05,
    Karlad02,
    Buenhd03,
    Ale04,
    Gera05,
    Dani06,
    Davidd07,
    Ferd08,
];

const awards2 = [
    Miguel10,
    Chris09,
    Karlad02,
    Davidd07,
    Dani06,
    Gera05,
    Ale04,
    Buenhd03,
];

const awards3 = [
    Karlad02,
    Davidd07,
    Miguel10,
    Chris09,
    Ferd08,
    Buenhd03,
    Dani06,
    Gera05,
];

const AwardSection: React.FC = () => {
    return (
        <section className="award pos-rel">
            <div className="container">
                <div className="row align-items-center">

                    {/* LEFT CONTENT */}
                    <div className="col-lg-6">
                        <div className="sec-title mb-30">
                            <span className="sub-title mb-20">Nosotros</span>
                            <h2 className="title title-line_height mb-5">
                                Nuestro Equipo
                            </h2>
                            <p className="content">
                               Somos un equipo de editores y animadores gráficos que transforma ideas en
                               piezas visuales impactantes. Unimos creatividad y precisión para crear
                               contenido dinámico, profesional y alineado con cada marca.
                            </p>

                            <div className="team-btn mt-40">
                                <Link className="thm-btn agency-btn" to="/contact">
                                    <span className="text">Contáctanos</span>

                                    <span className="arrow">
                                        <span className="arrow-icon">

                                            {/* First SVG */}
                                            <svg
                                                width="28"
                                                height="28"
                                                viewBox="0 0 28 28"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <rect
                                                    x="5.06592"
                                                    y="19.9785"
                                                    width="20.5712"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 5.06592 19.9785)"
                                                    fill="white"
                                                />
                                                <rect
                                                    x="7.97095"
                                                    y="7.24463"
                                                    width="2.61221"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 7.97095 7.24463)"
                                                    fill="white"
                                                />
                                                <rect
                                                    x="11.6523"
                                                    y="7.54834"
                                                    width="2.61221"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 11.6523 7.54834)"
                                                    fill="white"
                                                />
                                                <rect
                                                    x="15.334"
                                                    y="7.85205"
                                                    width="2.61221"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 15.334 7.85205)"
                                                    fill="white"
                                                />
                                                <rect
                                                    x="18.7119"
                                                    y="11.8374"
                                                    width="2.61221"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 18.7119 11.8374)"
                                                    fill="white"
                                                />
                                                <rect
                                                    x="18.4084"
                                                    y="15.52"
                                                    width="2.61221"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 18.4084 15.52)"
                                                    fill="white"
                                                />
                                                <rect
                                                    x="18.104"
                                                    y="19.2012"
                                                    width="2.61221"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 18.104 19.2012)"
                                                    fill="white"
                                                />
                                            </svg>

                                            {/* Second SVG */}
                                            <svg
                                                width="28"
                                                height="28"
                                                viewBox="0 0 28 28"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <rect
                                                    x="5.06592"
                                                    y="19.9785"
                                                    width="20.5712"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 5.06592 19.9785)"
                                                    fill="white"
                                                />
                                                <rect
                                                    x="7.97095"
                                                    y="7.24463"
                                                    width="2.61221"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 7.97095 7.24463)"
                                                    fill="white"
                                                />
                                                <rect
                                                    x="11.6523"
                                                    y="7.54834"
                                                    width="2.61221"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 11.6523 7.54834)"
                                                    fill="white"
                                                />
                                                <rect
                                                    x="15.334"
                                                    y="7.85205"
                                                    width="2.61221"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 15.334 7.85205)"
                                                    fill="white"
                                                />
                                                <rect
                                                    x="18.7119"
                                                    y="11.8374"
                                                    width="2.61221"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 18.7119 11.8374)"
                                                    fill="white"
                                                />
                                                <rect
                                                    x="18.4084"
                                                    y="15.52"
                                                    width="2.61221"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 18.4084 15.52)"
                                                    fill="white"
                                                />
                                                <rect
                                                    x="18.104"
                                                    y="19.2012"
                                                    width="2.61221"
                                                    height="2.61221"
                                                    transform="rotate(-40.2798 18.104 19.2012)"
                                                    fill="white"
                                                />
                                            </svg>
                                        </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT - MARQUEES */}
                    <div className="col-lg-6">
                        <div className="integration-logo-wrap ul_li">

                            {/* Marquee 1 */}
                            <div className="award-logo-inner marquee-first">
                                {awards1.map((img, i) => (
                                    <div className="integration-logo award-logo" key={i}>
                                        <img src={img} alt="award logo" />
                                    </div>
                                ))}
                            </div>
                        

                            {/* Marquee 2 */}
                            <div className="award-logo-inner marquee2">
                                {awards2.map((img, i) => (
                                    <div className="integration-logo award-logo" key={i}>
                                        <img src={img} alt="award logo" />
                                    </div>
                                ))}
                            </div>

                            {/* Marquee 3 */}
                            <div className="award-logo-inner marquee-first">
                                {awards3.map((img, i) => (
                                    <div className="integration-logo award-logo" key={i}>
                                        <img src={img} alt="award logo" />
                                    </div>
                                ))}
                            </div>

                            {/* SHAPES */}
                            <div className="xb-shape">
                                <div className="shape shape--1"></div>
                                <div className="shape shape--2"></div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

            <span className="award-gradiant"></span>
        </section>
    );
};

export default AwardSection;
